const dragOverlay = "_35sd1vqj8bl";

export { dragOverlay };
import "./_drag-overlay.style.linaria.module.css";
//# sourceMappingURL=_drag-overlay.style.js.map
